import * as React from "react";
import { useProductWithAFrameData } from "@grandvisionhq/fun-products";
import { TryInStoreAddButton } from "@grandvisionhq/fun-try-in-store";
const TryInStoreAddButtonGraphContainer = () => {
  const { activeVariant } = useProductWithAFrameData();
  return /* @__PURE__ */ React.createElement(
    TryInStoreAddButton,
    {
      slug: activeVariant.slug,
      sku: activeVariant.sku,
      isReservable: activeVariant.isReservable
    }
  );
};
export {
  TryInStoreAddButtonGraphContainer
};
//# sourceMappingURL=TryInStoreAddButtonGraphContainer.js.map
